// @flow
import { post } from './common';
import type { CartState } from '../reducers/cart';
import { initialState as cartState } from '../reducers/cart';
import { handleAPIErrors } from '../sentry-util';
import { MACHINE_SKUS } from '../reducers/cart';

export const saveCart = async (
	{ cart, mobile, sessionId, affiliateName }: { cart: CartState, mobile: string, sessionId: string, affiliateName:? string },
	cancel: boolean
) => {
	let reqBody = {};
	try {
		reqBody = {
			...parseCartForServer(cart),
			user_id: mobile,
			session_id: sessionId,
			affiliate_name: affiliateName
		};
		const res = await post(
			'/customer/app/cart',
			reqBody,
			{
				session: sessionId,
			},
			cancel
		);
		const { status = false, msg, data } = res;
		if (!status) {
			throw new Error(msg || 'Error while processing cart');
		}
		return parseCart(data[0], cartState);
	} catch (error) {
		handleAPIErrors(error, '/customer/app/cart', 'POST', reqBody);
		throw error;
	}
};

export const fetchCart = async ({
	cart,
	mobile,
	sessionId,
	affiliateName
}: {
	cart: CartState,
	mobile: string,
	sessionId: string,
	affiliateName:? string
}) => {
	let reqBody = {};
	try {
		reqBody = {
			...parseCartForServer(cart),
			user_id: mobile,
			session_id: sessionId,
			read_only: true,
			affiliate_name: affiliateName
		};

		const res = await post('/customer/app/cart', reqBody, {
			session: sessionId,
		});
		const { status = false, msg, data = [] } = res;
		if (!status) {
			throw new Error(msg || 'Error while processing cart');
		}
		return parseCart(data[0], cartState);
	} catch (error) {
		handleAPIErrors(error, '/customer/app/cart', 'POST', reqBody);
		throw error;
	}
};

export const parseCartForServer = (cart: CartState): any => {
	const { sku_json = {}, imei, machine, totalAmount = 0, totalQty = 0 } = cart || {};
	const skuList = (Object.entries(sku_json): Array<[string, any]>);
	const skusData = {};
	for (const [key, value] of skuList) {
		const { totalQty, totalAmount, skus } = value;
		skusData[key] = {
			total_items: totalQty,
			total_price: totalAmount.toString(),
			skus,
		};
	}

	return {
		sku_json: skusData,
		imei,
		machine_json: machine,
		total_items: totalQty,
		total_price: totalAmount.toString(),
	};
};

const parseCart = (data: any, prevCart: CartState): CartState => {
	if (data) {
		let skusData = {};
		const {
			sku_json = '{}',
			imei = '',
			machine_json = '{}',
			total_items = 0,
			total_price = 0,
			modified_at,
			created_at,
			cb_amount,
			cb_desc,
			delivery_discounted_fee = 0,
			delivery_list_fee = 0,
		} = data;
		let skuList = JSON.parse(sku_json);
		if (skuList && Array.isArray(skuList)) {
			skusData = {
				[MACHINE_SKUS]: {
					totalQty: +total_items,
					totalAmount: +total_price,
					totalBillValue: +total_price,
					skus: skuList,
				},
			};
		} else {
			skuList = (Object.entries(skuList): Array<[string, any]>);
			for (const [key, value] of skuList) {
				const { total_items, total_price, skus } = value;
				skusData[key] = {
					totalQty: +total_items,
					totalAmount: +total_price,
					skus,
				};
			}
		}

		return {
			...prevCart,
			sku_json: skusData,
			machine: JSON.parse(machine_json),
			imei,
			totalQty: +total_items,
			totalAmount: +total_price,
			isServer: true,
			lastUpdated: modified_at || created_at,
			cbAmount: +cb_amount,
			cbDesc: cb_desc,
			delivery_discounted_fee: +delivery_discounted_fee,
			delivery_list_fee: +delivery_list_fee,
		};
	}

	return {
		...cartState,
	};
};
